import { MediaGalleryBlock } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.state'
import { arrayItemUpdater, fieldReplacer, fieldUpdater } from '@shared/Frontend/utils/updaters'
import { Viewport } from '@shared/Frontend/utils/viewport'
import { BasicUpdater, Template } from 'ballerina-core'
import React, { ReactNode } from 'react'
import { MediaGalleryBlockState, MediaGalleryItemState } from './mediaGalleryBlock.state'

export type MediaGalleryBlockContext = {
  videoCookieAccepted: boolean
  viewport: Viewport
  id: string
} & MediaGalleryBlock
export type MediaGalleryBlockForeignMutationsExpected = { acceptVideoCookie: () => void }
export type MediaGalleryBlockView = {
  MediaGalleryBlock: (
    _: {
      id: string
      viewport: Viewport
      videoCookieAccepted: boolean
      acceptVideoCookie: () => void
      onOpen: (_: number) => void
      onClose: () => void
      onPrev: (_: number) => void
      onNext: (_: number) => void
    } & MediaGalleryBlock
  ) => ReactNode
}

export const MediaGalleryBlockTemplate = Template.Default<
  MediaGalleryBlockContext,
  MediaGalleryBlockState,
  MediaGalleryBlockForeignMutationsExpected,
  MediaGalleryBlockView
>(({ context, setState, foreignMutations, view }) => {
  const setItemsState = (updater: BasicUpdater<MediaGalleryBlockState['items']>) =>
    setState(fieldUpdater<MediaGalleryBlockState>()('items')(updater))
  return (
    <view.MediaGalleryBlock
      {...context}
      {...foreignMutations}
      onClose={() => setItemsState((state) => state.map(fieldReplacer<MediaGalleryItemState>()('isForeground')(false)))}
      onPrev={(foregroundIndex) =>
        setItemsState((mediaItems: MediaGalleryItemState[]): MediaGalleryItemState[] =>
          mediaItems.map(
            (media, index): MediaGalleryItemState =>
              index + 1 === foregroundIndex ? { ...media, isForeground: true } : { ...media, isForeground: false }
          )
        )
      }
      onNext={(foregroundIndex) =>
        setItemsState(
          (mediaItems): Array<MediaGalleryItemState> =>
            mediaItems.map(
              (media, index): MediaGalleryItemState =>
                index - 1 === foregroundIndex ? { ...media, isForeground: true } : { ...media, isForeground: false }
            )
        )
      }
      onOpen={(index) =>
        setItemsState(
          arrayItemUpdater<MediaGalleryItemState>(
            index,
            fieldReplacer<MediaGalleryItemState>()('isForeground')(true),
            fieldReplacer<MediaGalleryItemState>()('isForeground')(false)
          )
        )
      }
    />
  )
})
